import script from "./ReportAppendix.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportAppendix.vue?vue&type=script&setup=true&lang=js"

import "./ReportAppendix.vue?vue&type=style&index=0&id=2d620ccc&lang=css"
import "./ReportAppendix.vue?vue&type=style&index=1&id=2d620ccc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d620ccc"]])

export default __exports__